import styled from 'styled-components';

import { size, rgba } from '../layout/helpers';
import { theme } from '../layout/theme';

export const Toggle = styled.button.attrs(() => ({
  role: 'switch',
}))`
  width: ${size(7)};
  height: ${size(4)};
  border-radius: ${size(2)};
  background-color: ${theme.colors.toggle.bg};

  &:before {
    content: '';
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    border-radius: ${size(2)};
    background-color: ${theme.colors.ui.positive};
    opacity: 0;
    transition: opacity 150ms ease;
  }

  &.is-active {
    &:before {
      opacity: 1;
    }
  }
`;

export const Thumb = styled.span`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  width: ${size(4)};
  height: ${size(4)};
  color: ${theme.colors.toggle.bg};
  transition: transform 150ms ease;

  &:before {
    content: '';
    display: block;
    position: absolute;
    top: ${size(0.25)};
    bottom: ${size(0.25)};
    left: ${size(0.25)};
    right: ${size(0.25)};
    background-color: ${theme.colors.toggle.thumb};
    border-radius: 50%;
    box-shadow: 0px 0px ${size(1)} ${rgba(theme.colors.bg.alt, 0.12)};
  }

  > * {
    z-index: 1;
  }

  .is-active & {
    color: ${theme.colors.ui.positive};
    transform: translateX(${size(3)}); // Toggle width - Thumb width
  }
`;
